import {BrowserModule} from '@angular/platform-browser';
import {NgModule, inject, provideAppInitializer} from '@angular/core';
import {AppRootRoutingModule} from './app-root-routing.module';
import {AppRootComponent} from './app-root.component';
import {GraphQLModule} from './graphql.module';
import {HttpClient, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {OAuthModule, OAuthStorage} from 'angular-oauth2-oidc';
import {LibAuthModule} from 'lib-auth';
import {BusinessConfig, BusinessService, LibComponentsModule} from 'lib-components';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {loadFoundation} from './foundation-loader';
import {businessConfigInitializer} from './app-initializers';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isoWeek from 'dayjs/plugin/isoWeek';
import {provideTippyLoader, popperVariation, provideTippyConfig, tooltipVariation} from '@ngneat/helipopper/config';

loadFoundation();

export function createTranslateLoader(http: HttpClient): TranslateHttpLoader {
    return new TranslateHttpLoader(http, '/api/public/i18n/messages', '.json');
}

dayjs.extend(customParseFormat);
dayjs.extend(isoWeek);

@NgModule({
    declarations: [
        AppRootComponent
    ],
    bootstrap: [
        AppRootComponent
    ],
    imports: [
        BrowserModule,
        AppRootRoutingModule,
        GraphQLModule,
        OAuthModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
        LibAuthModule,
        LibComponentsModule
    ],
    providers: [
        {provide: OAuthStorage, useValue: localStorage},
        provideAppInitializer(() => {
            const initializerFn = ((businessService: BusinessService) => (): Promise<BusinessConfig> => businessConfigInitializer(businessService))(inject(BusinessService));
            return initializerFn();
        }),
        provideTippyLoader(() => import('tippy.js')),
        provideTippyConfig({
            defaultVariation: 'tooltip',
            variations: {
                tooltip: {
                    ...tooltipVariation,
                    theme: 'light'
                },
                popper: popperVariation,
            }
        }),
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class AppRootModule {
}
